var accordion = function () {
  return {
    openAccordions: [],
    allowMultiple: false, // 👈 control behavior per usage

    init() {},

    toggleAccordion(index) {
      if (this.allowMultiple) {
        const i = this.openAccordions.indexOf(index)

        if (i === -1) {
          this.openAccordions.push(index)
        } else {
          this.openAccordions.splice(i, 1)
        }

      } else {
        // 👇 only one open at a time
        if (this.openAccordions.includes(index)) {
          this.openAccordions = []
        } else {
          this.openAccordions = [index]
        }
      }
    },

    isOpen(index) {
      return this.openAccordions.includes(index)
    },

    toggleAccordionVideo(event) {
      const videoContainer = event.target
        .closest('.media-wrapper')
        ?.querySelector('.accordion__video')

      if (!videoContainer) return

      if (videoContainer.paused) {
        videoContainer.play()
        event.target.innerText = 'Pause'
      } else {
        videoContainer.pause()
        event.target.innerText = 'Play'
      }
    }
  }
}

document.addEventListener("alpine:init", () => {
  Alpine.data("accordion", accordion)
})